const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/*
 * Colori: despues de agregar al carrito con los botones personalizados
 * (custom-product-options.js y kit-builder.js usan /cart/add.js y luego redirigen al carrito),
 * esperamos solo hasta que el pixel de Meta registre "AddToCart" (normalmente <0.1 s, maximo 0.4 s).
 * Sin esto la pagina cambia antes de que el evento se envie.
 * Solo afecta a /cart/add.js; el carrito normal del tema (/cart/add) no cambia.
 */
(function () {
  if (!window.fetch || window.__coloriAtcDelay) return;
  window.__coloriAtcDelay = true;
  var MAX_WAIT_MS = 400;
  var POLL_MS = 25;

  function pixelEventCount() {
    try {
      var state = window.fbq && window.fbq.getState && window.fbq.getState();
      if (!state || !state.pixels || !state.pixels.length) return null;
      var total = 0;
      for (var i = 0; i < state.pixels.length; i++) total += state.pixels[i].eventCount || 0;
      return total;
    } catch (e) {
      return null;
    }
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = originalFetch.apply(this, arguments);
    if (!/\/cart\/add\.js(\?|$)/.test(url)) return promise;
    return promise.then(function (response) {
      // se mide al recibir la respuesta: el evento de este producto todavia no se ha enviado
      var countBefore = pixelEventCount();
      if (countBefore === null || !response.ok) return response;
      return new Promise(function (resolve) {
        var waited = 0;
        (function check() {
          var now = pixelEventCount();
          if (now === null || now > countBefore || waited >= MAX_WAIT_MS) {
            // pequeño margen para que el navegador envie la solicitud del evento
            setTimeout(function () { resolve(response); }, 50);
            return;
          }
          waited += POLL_MS;
          setTimeout(check, POLL_MS);
        })();
      });
    });
  };
})();
